/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Load_OlderInputs */

const cs_chat_load_older = /** @type {(inputs: Chat_Load_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst starší zprávy`)
};

const en_chat_load_older = /** @type {(inputs: Chat_Load_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load older messages`)
};

/**
* | output |
* | --- |
* | "Load older messages" |
*
* @param {Chat_Load_OlderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_load_older = /** @type {((inputs?: Chat_Load_OlderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Load_OlderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_load_older(inputs)
	return cs_chat_load_older(inputs)
});